// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3wPbR","spinner":"Spinner_spinner__1Neu5","spin":"Spinner_spin__2cA5G"};